import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserFullName } from '../utils/auth';
import './Profile.css';

interface ProfileProps {
  isOpen: boolean;
  onClose: () => void;
}

const Profile: React.FC<ProfileProps> = ({ isOpen, onClose }) => {
  const { user, logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      onClose();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  if (!isOpen || !user) return null;

  return (
    <div className="profile-overlay" onClick={onClose}>
      <div className="profile-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="profile__header">
          <button className="profile__close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="profile__logo">
            <span className="logo-text">CSZGLOBAL</span>
          </div>
        </div>

        <div className="profile__content">
          <div className="profile__title-section">
            <h2 className="profile__title">Your Profile</h2>
            <p className="profile__subtitle">Manage your casino builder account</p>
          </div>

          <div className="profile__info">
            <div className="profile__avatar">
              <div className="profile__avatar-inner">
                {user.first_name.charAt(0).toUpperCase()}
              </div>
            </div>

            <div className="profile__details">
              <div className="profile__detail">
                <label className="profile__detail-label">Full Name</label>
                <div className="profile__detail-value">{getUserFullName(user)}</div>
              </div>

              <div className="profile__detail">
                <label className="profile__detail-label">Email Address</label>
                <div className="profile__detail-value">{user.email}</div>
              </div>

              {user.phone && (
                <div className="profile__detail">
                  <label className="profile__detail-label">Phone</label>
                  <div className="profile__detail-value">{user.phone}</div>
                </div>
              )}

              <div className="profile__detail">
                <label className="profile__detail-label">Role</label>
                <div className="profile__detail-value">{user.role}</div>
              </div>

              <div className="profile__detail">
                <label className="profile__detail-label">Member Since</label>
                <div className="profile__detail-value">
                  {new Date(user.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="profile__actions">
            <button
              className="profile__logout"
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? 'Signing Out...' : 'Sign Out'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
